var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H16V16H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213 -164)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(214 165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,1a6,6,0,1,0,6,6A6.007,6.007,0,0,0,7,1M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z",
    transform: "translate(214 165)",
    fill: "#4fc169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.969,175.053a.5.5,0,0,1-.354-.146l-1.621-1.621a.5.5,0,0,1,.707-.707l1.267,1.267,3.463-3.463a.5.5,0,0,1,.707.707l-3.817,3.817A.5.5,0,0,1,219.969,175.053Z",
    transform: "translate(-0.067 -0.645)",
    fill: "#4fc169"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/active_icon.869de78fa6e49619cf1c58cc0accde5e.svg";
export { ForwardRef as ReactComponent };